// extracted by mini-css-extract-plugin
export var border = "CharacterSpacer-module--border--8e150";
export var character = "CharacterSpacer-module--character--46ee7";
export var cyan = "CharacterSpacer-module--cyan--0751e";
export var left = "CharacterSpacer-module--left--c3bf3";
export var pink = "CharacterSpacer-module--pink--922e0";
export var purple = "CharacterSpacer-module--purple--aaa92";
export var red = "CharacterSpacer-module--red--3c501";
export var root = "CharacterSpacer-module--root--94c98";
export var x1 = "CharacterSpacer-module--x1--59669";
export var x2 = "CharacterSpacer-module--x2--f6aeb";
export var x3 = "CharacterSpacer-module--x3--e726b";
export var x4 = "CharacterSpacer-module--x4--3183a";